export enum TimerEventType {
  START = "START",
  PAUSE = "PAUSE",
}
